
<template>
  <section class="bg-white ">
    <div class="max-w-screen-xl px-4 py-8 mx-auto space-y-12 lg:space-y-20 sm:py-16 lg:px-6">
      <!-- Row -->
      <div class="grid items-center lg:grid-cols-2 xl:gap-16 md-max:max-w-lg md-max:m-auto">
        <div class=" sm:text-lg  md-max:order-[2]">

          <!-- List -->
          <ul role="list" class="space-y-5 my-7">
            <li class="flex space-x-3">
              <!-- Icon -->


              <span class="textp">

                Imagine, for a moment, the lush highlands of Cajamarca, Peru, where the air is crisp and the soil is rich with life.
</span>
            </li>
            <li class="flex space-x-3">
              <!-- Icon -->
              <span class="textp">
                The sun gently rises over the Andean mountains, casting a warm golden glow on the vibrant green coffee plants that blanket the landscape.

</span>
            </li>
            <li class="flex space-x-3">
              <!-- Icon -->
              <span class="textp">

                Glistening dewdrops cling to the leaves as birdsong fills the air, adding a melodic soundtrack to the breathtaking panorama. Winding paths crisscross the verdant slopes, dotted with colorful flowers and towering trees that provide a haven for wildlife.

</span>
            </li>
          </ul>
        </div>
        <nuxt-img class="w-full mb-4 rounded-lg lg:mb-0 lg:flex"
                  width="584"
                  height="340"
                  loading="lazy"
                  format="webp"
                  sizes="xs:330px sm:440px md:600px lg:720px xl:584px 2xl:584px"
                  src="/assets/images/indonesia-1.jpg" alt="cajamarca image" />

      </div>
      <!-- Row -->
      <div class="items-center gap-8 lg:grid lg:grid-cols-2 xl:gap-16 md-max:max-w-lg md-max:m-auto">
        <nuxt-img class="w-full mb-4 rounded-lg lg:mb-0 lg:flex"
             src="/assets/images/indonesia-2.jpg"
             width="584"
             height="306"
             loading="lazy"
             format="webp"
             sizes="xs:330px sm:440px md:512px lg:479px xl:584px 2xl:584px"
             alt="indonesia image"/>
        <div class=" sm:text-lg">

          <h2 class="mb-4 font-extrabolds h2 ">It's here, in this idyllic setting, that our story begins, with a man named Rony Lavan.
          </h2>

          <p class="mb-8 textp">A passionate coffee farmer and entrepreneur, Rony has dedicated his life to cultivating the finest microlot coffee, while championing fair trade practices and sustainable agriculture.  </p>


        </div>
      </div>
    </div>
  </section>
</template>

<style scoped></style>


<script setup>

defineBuilderComponent({
    friendlyName: 'Content_Section',
    ignored: true
})

</script>